import { Component, OnInit } from '@angular/core';
import { Ticket } from '../../modelos/ticket';
import { MatDialogRef } from '@angular/material';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-lista-modal',
  templateUrl: './lista-modal.component.html',
  styleUrls: ['./lista-modal.component.scss']
})
export class ListaModalComponent implements OnInit {

  public listaTickets: Array<Ticket>;
  public title: string;

  constructor(public dialogRef: MatDialogRef<ListaModalComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/lista-modal/lista-modal.component.ts